import { render, staticRenderFns } from "./DisplayItem.vue?vue&type=template&id=5dc4d4e2&"
import script from "./DisplayItem.vue?vue&type=script&lang=ts&"
export * from "./DisplayItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports